import React, { Component } from 'react';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import NewMakeupForm from './NewMakeupForm';
import {
	ADD_MAKEUP_REQUEST, ADD_MAKEUP_FAILURE,
	MARK_AS_PAID_MAKEUP_SUCCESS, MARK_AS_PAID_MAKEUP_FAILURE
} from './actions';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const renderForm = (data, t, isReadonly, onSubmit) => {
	const initialValues = data && data.initialValues;
	return <NewMakeupForm data={data} t={t} isReadonly={isReadonly} onSubmit={onSubmit} initialValues={initialValues} />;
}

const renderFooter = (t, onHide, isReadonly, onSubmit) => {
	const closeBtn = <Button key='close' onClick={onHide}>{t('Common_Close')}</Button>;
	const saveBtn = <RemoteSubmitButton key='save' style='success' disabled={isReadonly} formName='newMakeupForm' label={t('Common_Save')} icon={faCheck} />;
	return [closeBtn, saveBtn];
}

const configureDialog = (t, onRenderForm, onHide, isReadonly) => {
	const footer = renderFooter(t, onHide, isReadonly);
	return {
		header: t('LessonAttendance_AddMakeup'),
		body: onRenderForm(),
		onHide,
		footer
	};
}

class NewMakeupDialog extends Component {

	constructor(props) {
		super(props);
		this.handleHide = this.handleHide.bind(this);
	}

	updateState(newState) {
		const oldState = this.state;
		this.setState({ ...oldState, ...newState });
	}

	handleHide() {
		const { onHide } = this.props;
		if (onHide) {
			onHide();
		}
	}

	prepareData() {
		const { data: { weeklyProgramItem, lessonDate }} = this.props;

		return {
			initialValues: {
				grade: weeklyProgramItem && weeklyProgramItem.grade,
				lessonDate
			}
		};
	}

	render() {
		const { t, show, isReadonly, onSubmit } = this.props;
		const preparedData = this.prepareData();
		const onRenderForm = () => renderForm(preparedData, t, isReadonly, onSubmit);
		const dialogConfig = configureDialog(t, onRenderForm, this.handleHide, isReadonly);
		
		return (
			<Dialog config={dialogConfig} show={show} t={t}
				block={[ADD_MAKEUP_REQUEST]}
				unblock={[ADD_MAKEUP_FAILURE, MARK_AS_PAID_MAKEUP_SUCCESS, MARK_AS_PAID_MAKEUP_FAILURE]} />
		);
	};
}

export default NewMakeupDialog;